const DailyEvents = ({ children }) => {
    return (
        <div className="main-content__calendar-events-daily">
            <div className="calendar-daily-table" data-date="2024-07-05">
                {children}
            </div>
        </div>
    );
};

export default DailyEvents;
